// Shows or hides the "Continue with Facebook" button in the auth modal. It is
// OFF until the Facebook app is approved and set to Live in Meta's developer
// dashboard (until then Facebook rejects every login with "App not active").
//
// UI only: useOAuthPopup, the funnel's Facebook provider and everything else
// stay as they are. The button is not rendered while this is false (it is
// absent from the DOM, not hidden with CSS). To turn it back on once the app
// is Live, set this to true -- and flip FACEBOOK_LOGIN_BUTTON_ENABLED in
// roammyway_funnel (lib/auth-providers.ts) too, so both sites match.
export const FACEBOOK_LOGIN_BUTTON_ENABLED = false;
